import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getCompanyList as getCompanyListApi,
	getCompany as getCompanyApi,
	addNewCompany as addNewCompanyApi,
	updateCompany as updateCompanyApi,
	deleteCompany as deleteCompanyApi,
} from '../../helpers/establishment/backend_helper';

export const getCompanyList = createAsyncThunk('companies/getCompanyList', async () => {
	try {
		const response = getCompanyListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getCompany = createAsyncThunk('companies/getCompany', async company_id => {
	try {
		const response = getCompanyApi(company_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewCompany = createAsyncThunk('companies/addNewCompany', async company => {
	try {
		const response = addNewCompanyApi(company);
		toast.success('Company agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar company.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateCompany = createAsyncThunk('companies/updateCompany', async (company) => {
		try {
			const response = updateCompanyApi(company);
			toast.success('Company actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar company.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteCompany = createAsyncThunk('companies/deleteCompany', async company => {
	try {
		const response = await deleteCompanyApi(company);
		toast.success('Company eliminado exitosamente.', { autoClose: 3000 });
		return { company, ...response };
	} catch (error) {
		toast.error('Error al eliminar company.', { autoClose: 3000 });
		throw new Error(error);
	}
});
